import React from 'react'
import { FormattedNumber } from 'react-intl'

import T from 'components/FormattedMessage'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles } from '@material-ui/core'
import { MessageKey } from 'types'

type UnitType = 'score' | 'cost'

type Props = {
  explicitPlus?: boolean
  value: number | undefined | null
  variant?: UnitType
  isCentered?: boolean
}

const styles = createStyles({
  unit: {
    marginLeft: 3,
  },
})

const unitTranslations: { [key in UnitType]: MessageKey } = {
  'score': 'common_unit_point',
  'cost': 'common_unit_budget',
}

type InjectedProps = Props & WithStyles<typeof styles>

const Point: React.SFC<InjectedProps> = ({ explicitPlus, value, variant, classes, isCentered }) => (
  <Grid wrap="nowrap" container justify={isCentered ? 'center' : 'flex-start'} alignItems="flex-end">
    <Grid item>
      <Typography component="div" variant="h4" color="inherit">
        {explicitPlus && Number(value) > 0 && '+'}
        <FormattedNumber value={Number(value) || 0} />
      </Typography>
    </Grid>
    <Grid item className={classes.unit}>
      <Typography variant="body2" color="inherit">
        <T id={unitTranslations[variant || 'score']} />
      </Typography>
    </Grid>
  </Grid>
)

export default withStyles(styles)(Point)
